import React from 'react';
import Jumbotron from 'react-bootstrap/Jumbotron';
 
const Contact = () => {
    return (
       <Jumbotron>
          <h1>Talk to me, guys!</h1>
          <p>There are plenty of ways you can contact me. On most sites, my username is ComputerCrafter.</p>
          <ul>
             <li><a rel="noopener noreferrer" target="_blank" href="https://www.youtube.com/channel/UCGg0EiXvSMDQiRhGUzKbbkA?">Youtube</a></li>
             <li><a rel="noopener noreferrer" target="_blank" href="https://www.reddit.com/user/ComputerCrafter">Reddit</a></li>
             <li><a rel="noopener noreferrer" target="_blank" href="https://artofproblemsolving.com/community/user/287243">Art of Problem Solving Fora</a></li>
          </ul>
       </Jumbotron>
    );
}
 
export default Contact;